module.exports = __webpack_public_path__ + "img/jh2.d50f62e7.png";